// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSnack_root__3kLyG"};